// extracted by mini-css-extract-plugin
export default {"opacity50Overlay":"Spinners_opacity50Overlay__b1eNd"};